import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import EmployeeType from 'types/EmployeeType'
import FluidImage from 'components/FluidImage'
import Link, { LINK_BEHAVIORS, LINK_SIZES, LINK_THEMES } from 'components/Link'
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton'
import Modal, { modalType } from 'components/Modal'
import LatestChroniclesBlock from 'components/LatestChroniclesBlock'

import * as css from './EmployeeModal.scss'

class EmployeeModal extends React.Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        ...EmployeeType
    }
    constructor() {
        super()

        this.state = {
            textExpandedInMobile: false
        }

        this._expandTextInMobile = this._expandTextInMobile.bind(this)
    }

    _expandTextInMobile() {
        this.setState({
            textExpandedInMobile: true
        })
    }

    render() {
        const {
            image,
            name,
            title,
            intro,
            phone,
            phoneFormatted,
            secondaryPhone,
            secondaryPhoneFormatted,
            email,
            modalLabels,
            onClose,
            latestChronicles
        } = this.props

        const { textExpandedInMobile } = this.state

        return (
            <Modal
                hasImage={image.url && !!image.url}
                labels={modalLabels}
                onClose={onClose}
                type={modalType.employee}
            >
                {image && image.url && (
                    <div className={css.imageContainer}>
                        <FluidImage
                            {...image}
                            className={css.image}
                            size={680}
                        />
                        <Link
                            url={image.url}
                            text={modalLabels.downloadImage}
                            theme={LINK_THEMES.lightTotal}
                            size={LINK_SIZES.small}
                            openInNewTab
                            className={css.downloadImageLink}
                        />
                    </div>
                )}
                <div
                    className={cn(css.content, {
                        [css.expandedInMobile]: textExpandedInMobile
                    })}
                >
                    <div>
                        <header>
                            <h2 className="h1">{name}</h2>
                        </header>
                        <h2>{title}</h2>
                        <div
                            className={cn(css.intro, 'wysiwyg')}
                            dangerouslySetInnerHTML={{ __html: intro }}
                        />
                    </div>
                    <div className={css.contacts}>
                        {email && (
                            <div className={css.contact}>
                                <h3 className={css.contactLabel}>
                                    {modalLabels.email}
                                </h3>
                                <Link 
                                    url={`mailto:${email}`}
                                    text={email}
                                    behavior={LINK_BEHAVIORS.text}
                                />
                            </div>
                        )}
                        {phone && (
                            <div className={css.contact}>
                                <h3 className={css.contactLabel}>
                                    {modalLabels.phone}
                                </h3>
                                <Link 
                                    url={`tel:${phoneFormatted}`}
                                    text={phone}
                                    behavior={LINK_BEHAVIORS.text}
                                />
                                {secondaryPhone && (
                                    <div>
                                        <Link 
                                            url={`tel:${secondaryPhoneFormatted}`}
                                            text={secondaryPhone}
                                            behavior={LINK_BEHAVIORS.text}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div>
                        <LatestChroniclesBlock {...latestChronicles} theme="short-view" />
                    </div>
                    {!textExpandedInMobile && (
                        <div className={css.expandButtonContainer}>
                            <LinkButton
                                text={modalLabels.showMore}
                                theme={LINK_BUTTON_THEMES.outlineDark}
                                fullWidth
                                onClick={this._expandTextInMobile}
                            />
                        </div>
                    )}
                </div>
            </Modal>
        )
    }
}

export default EmployeeModal
